import { queryOptions } from '@tanstack/react-query'

import { getExtendBenefit } from './extend-benefit.api'

export const extendBenefitQueries = {
  all: ['extendBenefit'],

  queryKey: (subscribeId: string) => [...extendBenefitQueries.all, subscribeId],

  benefit: ({ subscribeId, bearerToken }: { subscribeId: string; bearerToken?: string }) =>
    queryOptions({
      queryKey: extendBenefitQueries.queryKey(subscribeId),
      queryFn: async () => {
        const response = await getExtendBenefit(subscribeId, bearerToken)
        return response.data
      },
    }),
} as const
